
import "./AudioRecordingPreview.css"
import { useEffect, useMemo } from "react";
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
import { IRecordingInfo } from "../RecordingDialog";

function AudioRecordingPreview({ audioRecording }: {audioRecording?: IRecordingInfo}) {
    const audioRecordingUrl = useMemo(() => audioRecording ? URL.createObjectURL(audioRecording.recording) : undefined, [audioRecording]);

    useEffect(() => {
        return () => {
            if (audioRecordingUrl) {
                URL.revokeObjectURL(audioRecordingUrl);
            }
        };
    }, [audioRecordingUrl]);
    

    return (
        <div className="audio-recording__container">
            {!audioRecording &&
            (
                <div className="audio-recording__placeholder">
                    <AudiotrackIcon className="audio-recording__placeholder-icon"/>
                    <hr className="audio-recording__placeholder-track"/>
                </div>
            )}
            {
                audioRecording &&
                (   
                    <audio id="audio-recording" controls src={audioRecordingUrl}></audio>
                )
            }
        </div>
    )
}

export default AudioRecordingPreview;
